(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-template"] && !window.DesignMode) return;
  try {
    
  $( document ).ready(function() {
	var origin   = window.location.origin;
    console.log(origin);
	if (origin.includes("accessories")) 
    {		$('body').scrollTo(('h2').eq(2));}
	else if (origin.includes("bundles-collections")) 
    {	$('body').scrollTo(('h2').eq(1));}

});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-search"] && !window.DesignMode) return;
  try {
    
  jQuery(document).ready(function(){
    var leftSection = "";
    var rightSection = "";
    $('main .shopify-section--bordered').each(function(key, value){
        if((key+1) % 2 == 0) {
            rightSection = rightSection + $(this).html();
        } else {
            leftSection = leftSection + $(this).html();
        }
    });
    $('main .shopify-section--bordered').remove();
    
    jQuery('main').append("<div class='left-section col-6'>"+leftSection+"</div><div class='right-section col-6'>"+rightSection+"</div>");
    
  });

  } catch(e) { console.error(e); }
})();
})();
